import { IIconProps } from './add';

export const IcoStudies: React.FC<IIconProps> = ({ cy, style }) => (
  <svg
    width="19"
    height="15"
    viewBox="0 0 19 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={`IcoStudies${cy}`}
    style={style}
  >
    <path
      d="M16.5 2.25H9.5L7.75 0.5H2.5C1.52875 0.5 0.75875 1.27875 0.75875 2.25L0.75 12.75C0.75 13.7212 1.52875 14.5 2.5 14.5H16.5C17.4713 14.5 18.25 13.7212 18.25 12.75V4C18.25 3.02875 17.4713 2.25 16.5 2.25ZM15.625 9.25H13V11.875H11.25V9.25H8.625V7.5H11.25V4.875H13V7.5H15.625V9.25Z"
      fill="currentColor"
    />
  </svg>
);
